import React, { Component } from 'react';
import { push } from 'react-router-redux';
import { Router, Route, Link } from 'react-router'
import { asyncConnect } from 'redux-async-connect';
import { Buyer } from 'components';

@asyncConnect([{
  promise: ({store: {dispatch, getState}}) => {
    const promises = [];
    // if (!isInfoLoaded(getState())) {
    //   promises.push(dispatch(loadInfo()));
    // }
    return Promise.all(promises);
  }
}])

export default class TakePasswordOne extends Component {
  
  render() {
    
    return (
       <Buyer >
      <div style={{height:"100px"}}>ss</div>
      </Buyer>
    );
  }
}
